module.exports = __webpack_public_path__ + "img/compass-slash.e1dfaa6d.svg";